export default {
  day: '日',
  hour: '時間',
  min: '分',
  sec: '秒',
  cancel: 'キャンセル',
  confirm: '確認',
  showMore: 'もっと見る',
  hideMore: '非表示',
  per_sale: {
    title: 'プレセールフェーズは {days} 日 {hours} 時間 {mins} 分 {secs} 秒で終了します',
    title1: 'Public Saleに参加するには、まずKYCを完了する必要があります',
    text: 'DLCを購入',
    text1: 'KYCに参加する'
  },
  meau: {
    nav1: 'DeepLinkとは？',
    nav2: '購入方法',
    nav3: 'ホワイトペーパー',
    nav4: 'PITCH DECK',
    nav5: 'FAQ',
    nav6: 'Research',
    add: 'アドレス：',
    link: 'ウォレットを接続'
  },
  home: {
    intro: {
      title: 'DeepLink パブリックセール',
      text: 'パブリックセールの第一段階までのカウントダウン:',
      text1: '現在KYCが開始されています',
      text2: 'パブリックセール第5フェーズ終了までのカウントダウン',
      text3: '一般販売第2段階へのカウントダウン:',
      tip: '（DLC）トークンを購入する前に、お客様確認（KYC）の検証が完了していることを確認してください',
      tip1: '繰り返し購入しないでください'
    },
    desc: {
      title: 'Deeplinkは二つのコンポーネントから構成されています：DeepLink プロトコルとDeeplink ソフトウェア',
      left: {
        text: 'これらの各コンポーネントは支払いにDeepLinkトークンを利用します',
        text1: 'DeepLink Protocolは分散型AIクラウドゲームプロトコルで、',
        text2: 'AIとブロックチェーン技術を組み合わせて超低遅延のゲームレンダリング技術を提供し、DeepLink SoftwareはDeepLink Protocolに基づいて開発されたゲームリモートコントロールソフトウェアおよびクラウドゲームプラットフォームで、DeepLink Protocolに基づいて開発されたものには、クラウドインターネットカフェプラットフォーム、ブロックチェーンクラウドゲームコンソール、ブロックチェーンクラウドゲームハンドヘルドなどの他の製品があります',
        text3: '100%安全かつ検証済み',
        btn1: 'DeepLink Protocolの紹介',
        btn2: 'DeepLink Softwareの紹介',
      },
      right: {
        text1: 'パブリックセールが進行中です',
        text1_1: 'KYCが進行中です',
        text1_2: '一般販売フェーズ {pre_num1} が進行中です',
        // text2: 'DLC価格：1DLC={price}USDT, 残り{days}日{hour}時間{min}分',
        text2: 'DLC価格：1DLC={price}USDT',
        text3: '第{pre_num}回のパブリックセールはすでに終了しました',
        text4: 'フェーズ {pre_num1} が始まろうとしています',
        text5: 'パブリックセールが間もなく始まります',
        text6: '公開セールに参加する前に、お客様確認（KYC）プロセスを完了してください。ご協力ありがとうございます。',
        // text7: '現在の段階で10％のトークン追加報酬、次の段階では報酬が5％に減少',
        text7: '現在の段階で5％のトークン追加報酬、次の段階では追加報酬なし',
        text8: 'コミュニティに参加して、10,000 USDTとDLCが当たる抽選に参加しよう',
        process: '進行状況 {process}％',
        btn1: 'KYC認証に参加する',
        btn1_1: 'KYC合格',
        text7_1: '現在のウォレットKYCは審査中です。お待ちください',
        text7_2: '現在のウォレットKYCは審査を通過しました！',
        text7_3: '現在のウォレットKYCは審査に通過しませんでした。再提出してください！',
        text7_4: '現在のウォレットKYCは提出されていません',
        btn2: 'DLC TOKENを購入する',
        btn3: '5％の紹介リンク',
        btn3_1: '10％の紹介リンク',
        btn3_2: '15％の紹介リンク',
        btn3_3: '20％の紹介リンク'
      },
      success: 'リンクがクリップボードにコピーされました',
      error1: 'まずウォレットに接続し、専用の招待コードを取得して報酬を獲得してください',
      error2: 'ウォレットが接続されていません。まずウォレットに接続してください',

      error3: 'KYC 認証は審査中です。購入する前に審査を待ってください',
      error4: 'KYC 認証の審査に失敗しました。購入したい場合は、KYC 認証情報を再送信してください。',
      error5: 'KYC 認証情報の取得に失敗しました。後でもう一度お試しください。',
      error6: 'カウントダウン終了後、ぜひご購入にご参加ください',
      error7: '第3フェーズは終了しました。第4フェーズの開始をお待ちください。',
      tip1: "DLCはまだリリースされていません",
      tip2: "DLC はユーザーのウォレットに配布されました",
      tip3: '支払いは成功しました'
    },
    rule: {
      title: 'ルール説明',
      text1: 'KYC認証は必須であり、身分証明書、パスポート、運転免許証などの身分証明書の提出が必要です。シンガポール、中国、アメリカ合衆国、韓国、およびその他の特定の国の居住者はIDOに参加する資格がありません。',
      text2: 'パブリックセールの終了後、DLCはDEX取引所に7日以内に、CEX取引所に15日以内に上場されます。DLC トークンの BSC チェーン スマート コントラクト アドレス: 0xD610Be30b06A3828A27D608a38F1E85faAFdEDcC',
      text3: '20,000,000DLCの購入で、1500ドル相当のDeepLinkホームGPUゲームマイニングマシンを無料で入手できます。このオファーは日本とヨーロッパに限定されており、配送の詳細はメールで通知されます。',
      text3_btn: 'ホームGPUゲームマイニングマシンについて知る',
      text4: 'パブリックセールは発売後48時間で終了し、各DLCの価格は0.003 USDTです。トークンの40%はロック解除されたままになり、残りの60%は2024年8月31日から段階的にロック解除されます。DLCの40%は購入後数分以内に指定のウォレットアドレスに転送され、残りの60%は30日ごとに6回に分けてロック解除されることに注意してください。ロック解除時間に達すると、DLCはウォレットアドレスに転送されます。',
      text5: 'Public Saleは5回に分けて行われます。',
      table: {
        table1_text1: "ステージ",
        table1_text2: "2024/06/05-06/07",
        table1_text3: "2024/06/09-06/29",
        table1_text4: "2024/06/29-07/13",
        table1_text5: '2024/07/13-08/05',
        table1_text6: '2024/08/05-09/11',
        table2_text1: "DLC 金額",
        table2_text2: "350,000,000DLC",
        table2_text3: "400,000,000DLC",
        table2_text4: "300,000,000DLC",
        table2_text5: '450,000,000DLC',
        table2_text6: "未定",
        table3_text1: "DLC 価格（USDT）",
        table3_text2: "0.003",
        table3_text3: "0.003",
        table3_text4: "0.003",
        table3_text5: "0.003",
        table3_text6: "0.003",
        table4_text1: "ボーナス",
        table4_text2: "追加プレゼント 20% DLC",
        table4_text3: "追加プレゼント 15% DLC",
        table4_text4: "追加プレゼント 10% DLC",
        table4_text5: "追加プレゼント 5% DLC",
        table4_text6: "なし",
        table5_text1: "金額",
        table5_text2: "1,050,000 USDT",
        table5_text3: "1,200,000 USDT",
        table5_text4: '900,000 USDT',
        table5_text5: '1,350,000 USDT',
        table5_text6: "未定"
      }
    },  
    ecology: {
      title: 'DeepLinkプロトコルエコシステムの概要',
      block1_title: 'DeepLink ソフトウェア',
      block1_text1: 'DeepLinkソフトウェアの核心機能はリモートコントロールとクラウドゲーミングプラットフォームです',
      block1_text2: 'DeepLinkプロトコルは、DeepLinkプロトコルとDeepLinkソフトウェアの両方を含んでいます。その核心において、DeepLinkソフトウェアはリモートコントロールとクラウドゲーミングの機能を提供し、ユーザーがリモートゲーム、リモートワーク、クラウドベースのゲームサービスにアクセスできるようにします。現在、このソフトウェアは110カ国にわたるグローバルユーザーベースを持ち、40万回以上ダウンロードされ、世界中で20万以上のウォレットが作成されています。',
      block1_btn1: 'DeepLinkソフトウェアについて知る',
      block2_title: 'クラウドインターネットカフェとクラウドeスポーツ',
      block2_text1: 'クラウドインターネットカフェは、インターネットカフェとeスポーツサービスのための革新的なモデルを表しており、DeepLinkプロトコルの超低遅延レンダリング技術を活用しています。',
      block2_text2: 'この設定では、ゲームとアプリケーションはローカルコンピュータではなく、クラウドGPUサーバー上に存在し、ユーザーは高性能のローカルGPUホストを必要とせずにクラウドサービスを通じてゲームにアクセスしプレイできます。韓国、中国、日本、ベトナム、フィリピン、インドなど複数の国でDeepLink技術に基づくクラウドインターネットカフェの展開が進行中で、HYCONS、ZESTCLOUD、GLOWSTEAM、TIKERENなどの開発者が参加しており、韓国にはすでに運用例があります。',
      block2_btn1: '動画を見る',
      block2_btn2: 'クラウドインターネットカフェについて知る',
      block3_title: 'ブロックチェーンクラウドゲーム一体型PC',
      block3_text1: 'クラウドゲーム一体型PCとは何ですか？',
      block3_text2: 'ブロックチェーンクラウドゲーム一体型PCは、ゲームハードウェアの進化を象徴しており、高FPSリフレッシュレートを提供してシームレスなeスポーツゲーム体験を実現します。HKCグループによって開発されたTIKERENクラウドゲーム一体型PCは、DeepLinkの超低遅延レンダリング技術を利用してリアルタイムでクラウドGPUサーバーに接続し、ゲームのレンダリング性能を向上させます。',
      block3_btn1: 'ブロックチェーンクラウドゲーム一体型PCについて知る',
      block4_title: 'ブロックチェーンクラウドゲームハンドヘルド',
      block4_text1: 'クラウドゲームハンドヘルドとは何ですか？',
      block4_text2: 'DeepLinkの超低遅延レンダリング技術に基づいて構築されたクラウドゲームハンドヘルドは、従来のハンドヘルドと比較してコスト効率の高い選択肢を提供し、スムーズな3Aゲーム体験を実現します。クラウドGPUサーバーに接続してリアルタイムでゲームレンダリングを行うことで、ハンドヘルドのコストを70%削減します。',
      block4_btn1: 'ブロックチェーンクラウドゲームハンドヘルドについて知る'
    },
    coverage: {
      title: 'DeepLinkソフトウェアの世界ユーザー分布マップ',
      text: 'DeepLinkのユーザー総数：'
    },
    track: {
      title: 'DeepLink ProtocolはDePIN+AI+Gameの組み合わせトラックです',
      text: '現在のブロックチェーン業界のホットな分野に属しています',
      block1_title: 'DeepLinkの市場規模はどれくらいですか？',
      block1_text: "DeepLinkの機能の一つを分散型のXBOXやPlayStationと考えることができます。2023年末までにソニーのPS5の全世界販売台数は5000万台に達し、Xbox Series X|Sは3000万台に達しました。PSとXboxの総販売台数は2億台を超え、ハイエンド3Aゲーム市場の規模は巨大です。",
      block2_title: 'DeepLinkはXBOXやPlayStationと同様にハイエンド3Aゲームプレイヤーにサービスを提供しますが、ビジネスモデルは全く異なります',
      block2_text: 'DeepLinkのゲームプレイヤーは、高性能ゲームコンソールを自分で購入する必要はなく、DeepLinkソフトウェアをダウンロードするか、ブロックチェーンクラウドゲーム一体機またはブロックチェーンクラウドゲームハンドヘルドを購入するだけです。プレイヤーはXBOXやPlayStationと同様の3Aゲーム体験を得ることができますが、80%のハードウェアコストを節約できます。',
      block3_title: 'マイナーがハイエンド3Aゲームコンソールを提供し、コンソールはWindowsシステムで、すべてのWindows 3Aゲームと互換性があります。',
      block3_text: 'マイナーのゲームコンソールは自宅にもデータセンターにも置くことができますが、XboxやPlayStationのコンソールは自分自身でしか使用できず、他人に貸し出すことはできません。そのため使用効率が非常に低く、多くのリソースが無駄になっています。一方、DeepLinkのゲームマイニングマシンは、誰でも使用できるように共有することができ、ハードウェアリソースの利用率を高め、新しいビジネスモデルをもたらします。',
      block4_title: 'マイナーがゲームマイニングマシンを提供することで、DLCのトークン報酬を得ることができます',
      block4_text: 'これにより、より多くのマイナーがゲームマイニングマシンを提供することが促され、ユーザーはDLCトークンを支払ってゲーム時間を購入する必要があります。これにより、DLCの使用シナリオと保有者数が拡大し、潜在的なユーザー規模は10億人を超える可能性があります。',
      table: {
        table1_text1: '詳細比較',
        table1_text2: 'Deep Link',
        table1_text3: 'Xbox',
        table1_text4: 'PS5',
        table2_text1: '3Aゲームをプレイする',
        table2_text2: 'ユーザーはハードウェアを購入する必要がなく、DeepLinkソフトウェアをダウンロードするだけです',
        table2_text3: 'ユーザーはハードウェアを購入する必要があります',
        table2_text4: 'ユーザーはハードウェアを購入する必要があります',
        table3_text1: 'ゲームコンソール',
        table3_text2: '$DLCを稼ぐために貸し出すことができ、1日に12時間以上貸し出すことができ、10ヶ月で元が取れます',
        table3_text3: '自分だけが使用可能で、貸し出すことはできず、1日に2〜4時間の使用でハードウェアリソースが無駄になっています',
        table3_text4: '自分だけが使用可能で、貸し出すことはできず、1日に2〜4時間の使用でハードウェアリソースが無駄になっています',
        table4_text1: 'ハンドヘルド',
        table4_text2: 'サポートされており、任意のハードウェアに接続できます',
        table4_text3: '専用のハンドヘルドはありません',
        table4_text4: 'サポートされており、PS5にのみ接続できます',
        table5_text1: 'クラウドゲーム一体型PC',
        table5_text2: 'サポートされています',
        table5_text3: 'サポートされていません',
        table5_text4: 'サポートされていません',
        table6_text1: 'クラウドインターネットカフェ',
        table6_text2: 'サポートされています',
        table6_text3: 'サポートされていません',
        table6_text4: 'サポートされていません',
      },
      btn1: 'DeepLink ソフトウェア',
      btn2: 'DeepLink プロトコル',
      btn3: 'チーム紹介',
      btn4: '経済モデル'
    },
    faqs: {
      title: 'FAQS',
      text: '質問があるかもしれませんが、私たちは答えを持っています。',
      ques_title1: '1.Public Saleとは何ですか？',
      ques_text1: 'Public Sale期間中、限定数量のTokenが特定の価格で早期参加を希望する人々に販売されます。これは、実際のToken発行前に人々がDeepLinkの一部になることができる絶好の機会です。Public Saleに参加することで、Tokenが公に発行される前に早期価格で購入することができます。したがって、Public SaleはTokenが流通し取引所に上場する前にそれらを購入する潜在的な機会と考えることができます。',
      ques_title2: '2.なぜPublic Saleを行うのですか？',
      ques_text2_1: '私たちはPublic Saleを行い、強力な$DLCホルダーコミュニティを構築し、プラットフォームを改善し、資金を調達し、より多くのゲームプレイヤーを私たちのエコシステムに引き込むためです。',
      ques_text2_2: 'Public Sale期間中に集められた資金は、DeepLinkの製品に再投資され、新機能を導入し、マーケティング活動を通じてユーザーベースを拡大します。これにより、$DLC Tokenが発行される前に市場戦略を実行できます。',
      ques_text2_3: '私たちの目標は、1,000,000,000人がDeepLinkを使用することで、$DLC Tokenの大規模な使用シナリオを生み出し、$DLC Tokenの長期的な成功を保証することです。$DLC TokenはDEXおよびCEX取引所に上場され、DeepLinkエコシステムの成長をさらに推進します。',
      ques_text2_4: '今すぐDeepLink Public Saleに参加して、DeepLinkの一部になりましょう！',
      ques_title3: '3.DeepLink ProtocolとDeepLink Softwareの違いは何ですか？',
      ques_text3_1: 'DeepLink Protocolは、AIとブロックチェーン技術を組み合わせた分散型AIクラウドゲームプロトコルで、超低遅延のゲームレンダリング技術を提供します。',
      ques_text3_2: 'DeepLink Softwareは、DeepLink Protocolに基づいて開発されたゲームリモートコントロールソフトウェアおよびクラウドゲームプラットフォームです。',
      ques_text3_3: 'DeepLink Protocolに基づいて開発されたその他の製品には、クラウドeスポーツインターネットカフェプラットフォーム、ブロックチェーンクラウドゲーム一体型PC、ブロックチェーンクラウドゲームハンドヘルドなどがあります。',
      ques_title4: '4.DeepLink Protocolの革新性はどこにありますか？',
      ques_text4: 'DeepLinkはブロックチェーンとAI技術を使用してクラウドゲーム業界が直面している核心的な困難を解決し、Tokenインセンティブメカニズムを通じてマイナーとアイドルGPUマシンの参加を促し、アイドル帯域幅トラフィックの参加を促します。これにより、クラウドゲーム業界が直面している2つの主要な難点を解決します。AI技術によりゲーム画質が向上し、ユーザーエクスペリエンスが向上します。',
      ques_title5: '5.$DLC Tokenとは何ですか？',
      ques_text5: '$DLC TokenはDeepLinkエコシステム内の唯一の支払い証明で、ユーザーはクラウドゲームの時間を購入したり、クラウドゲームPCをレンタルしたり、ライセンス認証を購入するために$DLC Tokenを支払う必要があります。',
      ques_title6: '6.DeepLink Protocolのターゲットカスタマーは誰ですか？',
      ques_text6_1: '1）3Aゲーム会社：3Aゲームをクラウドゲームに変換するのに役立ち、それによって3Aゲームを任意のローエンドデバイスで実行できるようにし、3Aゲームのユーザーベースを10倍以上に増やすことができます。',
      ques_text6_2: '2）インターネットカフェとeスポーツホテル：従来のインターネットカフェをアップグレードし、クラウドインターネットカフェに変換するのに役立ち、インターネットカフェのハードウェア投資を80%以上削減し、4年間で純利益を3倍に増やすことができます。',
      ques_text6_3: '3）クラウドゲーム一体型PCハードウェアメーカー：メーカーがDeepLink Protocolを統合すると、ローエンドCPU構成とハイエンドゲームスクリーンを使用して3Aゲームをスムーズにプレイでき、プレイヤーはハードウェア投資を80%節約できます。',
      ques_text6_4: '4）クラウドゲームハンドヘルドハードウェアメーカー：メーカーがDeepLink Protocolを統合すると、ハンドヘルドの価格は従来のハンドヘルドの30%で、ゲームパフォーマンスは従来のハンドヘルドの5倍以上になります。',
      ques_title7: '7.DeepLink Softwareのターゲットカスタマーは誰ですか？',
      ques_text7: '全世界30億人の潜在的な個人ゲームプレイヤーであり、ゲームプレイヤーは携帯電話、性能の低いコンピューター、またはMacとテレビを使用してハイエンド3Aゲームをスムーズにプレイできます。',
      ques_title8: '8.ベスティング期間はありますか？',
      ques_text8: '購入したDLC Tokenの40%にはロックがかかっておらず、60%は2024年8月31日から3日以内にロック解除が始まり、150日かけてロック解除され、30日ごとに10%がロック解除されます。',
      ques_title9: '9.$DLCを購入する方法は？',
      ques_text9: 'まずKYCに参加し、個人情報を提出します。認証が完了したら、Public Saleが開始されたときに$DLCの購入に参加できます。',
    },
    buy: {
      title: '購入方法',
      step1: 'ステップ 1:',
      step1_text: 'ウォレットを接続：MetamaskまたはTrust Walletを使用して数秒でウォレットを接続します',
      step2: 'ステップ 2:',
      step2_text: '取引の確認: USDTで$DLCを購入できます。',
      step3: 'ステップ 3:',
      step3_text: 'トークンを請求：おめでとうございます！Public Saleが終了した後に$DLCを請求できます。',
      btn1: 'ヘルプが必要',
      btn2: 'DLCを購入',
    },
    potential: {
      title: '成長ポテンシャル',
      text1_1: 'DePINトラックの複数のトークンが取引所に上場した後、市場価値は絶えず増加しています',
      text1_2: '$ 888',
      text1_3: '$ 2288',
      text1_4: '$ 5888',
      text1_5: '$ 12888',
      text2: 'DeepLink Softwareの潜在的なユーザー規模は10億を超え、多くのweb2ユーザーをweb3の世界に導きます。$DLCの潜在的な保有者は10億人以上になるでしょう。',
      text3: '世界には20万以上のeスポーツインターネットカフェがあり、将来的には50％以上の従来のインターネットカフェがクラウドインターネットカフェに改造される予定です。クラウドインターネットカフェの技術応用の展望は広く、各クラウドインターネットカフェは$DLCでの支払いが必要となり、$DLCの大量使用をもたらします。',
      text4: 'XBOXとPS5の販売数を参照にすると、ブロックチェーンクラウドゲーム一体型PCおよびブロックチェーンクラウドゲームハンドヘルドを購入するユーザー層は1億人を超えると予想され、これは$DLCに大きな価値をもたらすでしょう。'
    },
    report: {
      title: 'DeepLink メディア報道'
    },
    prompt: {
      title: '説明とヒント',
      text1: 'DeepCloudX.PTE.LTDはdeeplink.cloudウェブサイト（「プラットフォーム」）を運営しています。',
      text2: 'このプラットフォームを使用することにより、あなたは私たちの利用規約、プライバシーポリシー、Cookieポリシー、およびDLCトークン販売契約に同意することになります。あなたの司法管轄区内では、暗号通貨は規制されていない可能性があります。暗号通貨の価値は上昇することも下降することもあります。利益は、あなたの司法管轄区内で適用される資本利得税やその他の税金によって影響を受ける可能性があります。このウェブサイト上のどんな内容も、購入、売却、または投資の申し出や推奨として解釈されるべきではありません。あなたは、個人的な目標、財務状況、リスク許容度に基づいて、任意の購入や関連する取引が自分に適しているかどうかを自身で判断する責任があります。',
      text3: '法律、税金、保険、またはビジネスに関するアドバイスを得るために、信頼できる、ライセンスを持つ法律専門家や顧問に相談するべきです。DLCは、このウェブサイト上のいかなる暗号通貨についても、いかなるパフォーマンス、結果、または資本リターンを保証しません。このウェブサイトおよびその任意のページにアクセスすることにより、あなたはDLC販売契約の束縛を受け入れることに同意します。暗号通貨の購入にはリスクが伴い、部分的または全体的な損失につながる可能性があります。'
    }
  },
  dialog1: {
    title: 'KYC情報の提出',
    text1: '身分情報のアップロード：',
    text2: '手持ちの身分情報のアップロード：',
    text3: '身分証明書、パスポート、運転免許証の表面情報',
    text4: '顔と身分情報がはっきりと見える必要があります',
    text5: 'DLCの購入申請数：',
    text6: '認証されたウォレットアドレス：',
    text7: 'KYC認証が通過した後、1000DLCが報酬として与えられ、Public SaleでロックされたDLCもこのウォレットアドレスに送られます',
    text7_1: 'このアドレスのみがKYC検証を通過するとDLCを購入できます。取引所のアドレスは使用できません',
    text8: 'DBCチェーンのDLCウォレットアドレスをどこで作成しますか？',
    text9: 'または',
    text10: 'メールアドレスの入力：',
    text11: '認証コードの取得',
    text12: '認証コードの入力：',
    text13: '{secs}秒後に再取得',
    text14: '(最大20,000,000DLC、Pubic Sale開始時はKYC認証を通過した数量のみ購入可能)',

    success1: '認証コードが送信されました!',
    success2: '情報は正常に送信され、審査を待っています',
    error1: '画像ファイルを選択する必要があります!',
    error2: '画像ファイルは空ではいけません!',
    error3: 'ユーザー名を空にすることはできません!',
    error4: 'ウォレットアドレスを空にすることはできません!',
    error5: 'メールアドレスを空にすることはできません!',
    error6: '正しいメールアドレスを入力してください!',
    error7: '認証コードを空にすることはできません!',
    error8: '認証コードの送信に失敗しました。しばらくしてから再試行してください！',
    error9: '追加に失敗しました',
    error10: '認証コードが間違っています。再試行してください',
    error11: 'メール情報の照会に失敗しました',
    error12: '購入数量は20,000,000を超えることはできません',
    error13: '認証コードの有効期限が切れました。再取得してください',
    error14: '情報の提出に成功しましたが、確認メールの送信に失敗しました',
    error15: 'メールが届かない場合は、迷惑メールフォルダを確認してください',
    error16: '画像のアップロード最大サイズは5MBを超えてはいけません',
    error17: 'KYC検証データを繰り返し提出しないでください。',
    tip1: '(注意事項: 個人を特定できる情報は KYC のみに使用され、他の目的には使用されません。)'
  },
  dialog2: {
    title: 'DLCを購入する',
    text1: 'DLCの購入申請数量：',
    text2: '最低150,000DLCを購入する必要があります',
    text3: '支払い通貨を選択：',
    text4: 'DBCチェーンのDLCウォレットアドレスを入力：',
    // text5: 'ロックされたDLCはこのウォレットアドレスに送られます。ウォレットアドレスの正確さを確認してください。DLCを受け取れない事態を防いでください！',
    text5: 'DLC の 40% は数分以内にこのウォレット アドレスに転送され、ロックの有効期限が切れると、DLC の残りの 60% がこのウォレット アドレスに転送されます。',
    text6: 'DBCチェーンのDLCウォレットアドレスはどこで作成しますか？',
    text7: 'または',
    text8: '等価のUSDT:',
    text9: '支払い方法を選択：',
    text9_1: '現在接続されているウォレットで支払う',
    text9_2: 'QRコードで支払う',
    error1: 'DLC数量を空にすることはできません',
    error2: '数字を入力してください',
    error3: '入力された数字は50000より大きくなければなりません',
    error4: 'ウォレットアドレスを空にすることはできません',
    error5: '注文の作成に失敗しました',
    success1: '支払いは成功しました。DLC は数分以内にウォレットのアドレスに転送されます。注意して確認してください。 ',
    success2: 'ジャンプリンクを介して支払いが成功すると、数分以内にDLCがあなたのウォレットアドレスに転送されますので、注意して確認してください。',

    error6: 'USDT 数量を空にすることはできません',
    error7: 'USDT の金額は 150 未満にすることはできません',
    error8: 'USDT の金額は 60000 を超えることはできません',
    error9: '支払い金額が事前入金金額と一致しません。正しいかどうかを管理者に確認してください。'
  },
  dialog3: {
    title: '一体機の紹介',
    text1: '1.クラウドゲーム一体機とは何ですか？',
    text2: 'クラウドゲーム一体機は、従来の一体機に比べて高FPSのリフレッシュレートを持つディスプレイを搭載し、スムーズなゲーム体験を実現します。HKCグループのTIKERENクラウドゲーム一体機は、DeepBrainChain+DeepLinkの技術を基に開発され、リアルタイムで遠隔地の高性能GPUの計算能力に接続し、ゲームのレンダリングと計算を行います。一体機にはWindowsシステムが内蔵されており、通常のオフィスやエンターテインメントとして使用でき、DeepLinkを通じて自身の他の高性能GPUホストでゲームをプレイすることができます。自身が高性能GPUホストを持っていない場合は、DeepLinkを通じて遠隔地の高性能GPUに接続し、3Aゲームをプレイすることができます。この際、1時間あたり一定のDLC Tokenを支払う必要があります。',
    text3: '2.TIKEREN一体機の展示',
    table: {
      th: {
        text1: 'プロジェクト',
        text2: '27インチ',
        text3: '31.5インチ',
      },
      td1: {
        text1: 'Mode Type',
        text2: 'MA27H13QC1',
        text3: 'MA27H13QC1'
      },
      td2: {
        text1: 'Color Category',
        text2: 'Black',
        text3: 'Black'
      },
      td3: {
        text1: 'Display Size',
        text2: '27インチ',
        text3: '31.5インチ'
      },
      td4: {
        text1: 'Aspect Ratio',
        text2: 'Wide (16:9)',
        text3: 'Wide (16:9)'
      },
      td5: {
        text1: 'Panel Type',
        text2: 'IPS',
        text3: 'VA'
      },
      td6: {
        text1: 'Panel Resolution',
        text2: 'QHD 2560*1440',
        text3: 'QHD 2560*1440'
      },
      td7: {
        text1: 'Panel Refresh Rate',
        text2: '180Hz (Max)',
        text3: '170Hz(Max)'
      },
      td8: {
        text1: 'Responese Time',
        text2: '1mS(MPRT) GTG 1ms',
        text3: '1ms(MPRT) GTG 1ms'
      },
      td9: {
        text1: 'Color Gamut',
        text2: 'DCIP3 90%',
        text3: 'DCIP3 90%'
      },
      td10: {
        text1: 'Mainboard Solution',
        text2: 'Intel® N100 Chipset',
        text3: 'Intel® N100 Chipset'
      },
      td11: {
        text1: 'CPU/Cooler',
        text2: 'Intel N100 3.4GHz',
        text3: 'Intel N100 3.4GHz'
      },
      td12: {
        text1: 'Memory',
        text2: 'DDR4 8GB(Option Max 32G)',
        text3: 'DDR4 8GB(Option Max 32G)'
      },
      td13: {
        text1: 'Hard Disk',
        text2: 'SSD 128G(Option Max 1T)',
        text3: 'SSD 128G(Option Max 1T)'
      },
      td14: {
        text1: 'OS',
        text2: 'Windows 10/11(0ption)',
        text3: 'Windows 10/11(0ption)'
      },
      td15: {
        text1: 'GPU',
        text2: 'Intel UHD Graphics',
        text3: 'Intel UHD Graphics'
      },
      td16: {
        text1: 'Rear Interface',
        text2: '1*DC Power Connector，1*RJ45(2.5G)，4* USB 3.0，1*Audio jacks',
        text3: '1*DC Power Connector，1*HDMIN，1*HDMI OUT，1*RJ45(2.5G)，4* USB 3.0,1*Audio iacks'
      },
      td17: {
        text1: 'Side Interface',
        text2: 'USB 2.0x2，Power Button x1',
        text3: 'USB 2.0x2，Power Button x1'
      },
      td18: {
        text1: 'Wi-Fi',
        text2: '2.4G~5GHz(Wi-Fi5)，BT(4.2)',
        text3: '2.4G~5GHz(Wi-Fi5)，BT(4.2)'
      },
      td19: {
        text1: 'Audio',
        text2: 'Built-in Speakers*2',
        text3: 'Built-in Speakers*2'
      },
      td20: {
        text1: 'Base/Stand',
        text2: 'HAS:VESA',
        text3: 'HAS:VESA'
      },
      td21: {
        text1: 'Pivot',
        text2: '上、下、左、右、90°回転、昇降',
        text3: '上、下、左、右、90°回転、昇降'
      },
      td22: {
        text1: 'Power',
        text2: '90W',
        text3: '90W'
      },
      td23: {
        text1: 'Game Screen lmprovement',
        text2: 'Free Sync, G-Sync',
        text3: 'Free Sync, G-Sync'
      }
    },
    btn: '了解しました'
  },
  dialog4: {
    title: 'クラウドゲームハンドヘルドの紹介',
    text1: '1.クラウドゲームハンドヘルドとは何ですか？',
    text2: 'クラウドゲームハンドヘルドは、従来のハンドヘルドと比較して、DeepLinkの超低遅延レンダリング技術に基づいて開発されています。これにより、リアルタイムでクラウド上のGPUサーバーの高性能計算能力に接続し、ゲームレンダリングを行うことができ、ハンドヘルドのコストを70%削減しながら、スムーズな3Aゲーム体験を実現します。ハンドヘルドにはGoogle Playが内蔵されており、Androidゲームをダウンロードすることができますし、自身の他の高性能Windows GPUホスト/PS/XBOXにストリーミングしてゲームをプレイすることも可能です。自身が高性能GPUホストを持っていない場合でも、DeepLinkを通じて遠隔地の高性能GPUホストに接続し、3Aゲームをプレイすることができます。この際、1時間あたり一定のDLCトークンを支払う必要があります。',
    text3: '2.ブロックチェーンクラウドゲームハンドヘルドの展示',
    btn: '了解しました'
  },
  dialog5: {
    title: '家庭用GPUゲームマイニングマシンの紹介',
    text1: '1.家庭用GPUゲームマイニングマシンとは何ですか？',
    text2: 'GPUゲームマイニングマシンには、NVIDIA 4070 Super GPU、Intel i7-13700F CPU、32GBのメモリ、2TBのSSDストレージが搭載されており、DeepLinkのマイニングソフトウェアと管理システムが内蔵されています。誰でもこのマシンを自宅に置いてDLCの報酬を得ることができ、年間10億DLCトークンがすべてのゲームマイニングマシンに報酬として与えられます。ユーザーがマシンをレンタルしてゲームをプレイしていなくても、DLCの報酬を得ることができます。GPUゲームマイニングマシンをレンタルに設定すると、DLCの報酬とDBCのレンタル収入を得ることができ、ユーザーがレンタルしていない時でも他のトークンをマイニングし、24時間収益を生み出すことができます。',
    text3: '2.家庭用GPUゲームマイニングマシンの展示',
    text4: '3.スペック紹介',
    text5_1: 'RTX4070 Superグラフィックカード搭載',
    text5_2: 'Core i7-13700F、16コア、24スレッド、ベース1.5/2.1 GHz、最大4.1/5.1GHz;',
    text5_3: 'グラフィックカード GeForce RTX4070 Super 12G。第3世代レイトレーシングおよび第4テンソルコアをサポート。',
    text5_4: 'RAMデュアルDDR4、最大64GB（32GB2）。',
    text5_5: 'ハードドライブポートは1つのM2 2280 NVME SSD、および2つの2.5インチSATAハードドライブを追加するサポート。',
    text5_6: 'ポートは4USB 3.2、4* USB 2.0、3DisplayPort、1HDMI、2LAN、1Optical、1Audio、1DC-IN、2*WiFiポート。',
    text5_7: 'オペレーティングシステムはWindows 11 Proがプリインストールされています。',
    btn: '了解しました'
  }
}